/**
 * Mobile Mega Menu Swiper Initialization
 */
class MobileMegaMenu {
  constructor() {
    this.swipers = [];
    this.init();
    
    // Watch for drawer open event if possible, or use a MutationObserver
    // Dawn's header-drawer usually manages its own state via details/summary or a custom element.
    this.observeDrawer();
  }

  init() {
    const swiperEls = document.querySelectorAll('.mobile-mega-swiper');
    if (!swiperEls.length) return;

    swiperEls.forEach(el => {
      // Check if already initialized
      if (el.classList.contains('swiper-initialized')) return;

      const swiper = new Swiper(el, {
        slidesPerView: 'auto',
        spaceBetween: 15,
        freeMode: true,
        grabCursor: true,
        observer: true,
        observeParents: true
      });
      this.swipers.push(swiper);
    });
  }

  observeDrawer() {
    const drawer = document.querySelector('header-drawer');
    if (!drawer) return;

    // We can listen for the open status. 
    // Dawn's HeaderDrawer component typically toggles an 'open' attribute or class on some internal element.
    // Or we can just re-init on click of a summary tag.
    
    drawer.addEventListener('click', (e) => {
      const summary = e.target.closest('summary');
      if (summary) {
        // Delay slightly to allow content to show
        setTimeout(() => this.init(), 100);
      }
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.mobileMegaMenu = new MobileMegaMenu();
});
